/**
 * Triggered when Mail List is rendered
 */
export const MAILLIST_RENDERED = 'MailListRendered';
